import ContextMenuPlugin from './lib/index'

export default ContextMenuPlugin
